/**
 * Fade+translateY entrance animation for newly-inserted "Load More" items,
 * shared by every AJAX load-more handler in the theme (events, blog,
 * podcasts, past events, personal pages) so a future 5th load-more surface
 * never needs its own copy (JCTCTAS-39). Extracted from events-ajax.js's
 * own former local `animateCardsIn` -- that was the one working reference
 * implementation in the theme; every other handler previously inserted new
 * items with no animation at all.
 *
 * Toggles a shared `.js-card-enter` class. assets/src/scss/base/_base.scss
 * defines the generic `@keyframes jctc-card-enter` + `prefers-reduced-motion`
 * guard this class triggers -- a global utility rule, not scoped to any one
 * component, so blog cards / podcast cards / personal-page rows / past-event
 * cards all get it automatically with zero new SCSS per component.
 * assets/src/scss/blocks/_events.scss's own, more specific
 * `.event-card.js-card-enter` rule (higher specificity, its own
 * `jctc-event-card-enter` keyframes) still wins for event cards specifically,
 * unchanged -- this shared utility only had to be safe to ADD, not replace
 * that already-verified-working rule.
 *
 * Skipped entirely under reduced motion, not just left to the SCSS's own
 * `animation: none` override -- per spec, `animation: none` never fires
 * `animationend`, so the cleanup listener below would never run and this
 * class would sit on every item, permanently, for the rest of a
 * reduced-motion visitor's session (dead weight; not visually broken, since
 * no keyframe runs either way, but no reason to leave it).
 *
 * @param {Element[]|NodeListOf<Element>} items Newly-inserted elements only
 *   -- callers are responsible for isolating these (insertAdjacentHTML
 *   gives back no reference to what it just parsed in, so the usual pattern
 *   is counting matching elements before/after insertion and slicing the
 *   difference).
 */
export const animateItemsIn = (items) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }
    Array.from(items).forEach((item) => {
        item.classList.add('js-card-enter');
        item.addEventListener('animationend', () => item.classList.remove('js-card-enter'), {
            once: true,
        });
    });
};
